import React from 'react';
import { Typography, Divider, Card } from 'antd';
import Navbar from './Navbar';
import Footer from '../component/Footer';

const { Title, Paragraph, Text } = Typography;

const TermsAndConditions = () => {
    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
            <Navbar />
            <div style={{ flex: 1, padding: '60px 20px', display: 'flex', justifyContent: 'center' }}>
                <Card 
                    bordered={false} 
                    style={{ 
                        width: '100%', 
                        maxWidth: 1000, 
                        borderRadius: 24, 
                        boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                        padding: '20px 40px' 
                    }}
                >
                    <Title level={1} style={{ color: '#0B1F4D', fontWeight: 800, textAlign: 'center', marginBottom: 10 }}>Terms and Conditions</Title>
                    <div style={{ textAlign: 'center', marginBottom: 30 }}>
                        <Text type="secondary" style={{ fontSize: 16 }}>
                            Last Updated: {new Date().toLocaleDateString()}
                        </Text>
                    </div>
                    <Divider style={{ borderColor: '#FF8110', borderWidth: 2, width: '100px', minWidth: '100px', margin: '0 auto 40px auto' }} />
                    
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        Welcome to Nearzon! These terms and conditions outline the rules and regulations for the use of Nearzon's Website and Marketplace. By accessing this website we assume you accept these terms and conditions.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>1. Acceptance of Terms</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        By accessing this website we assume you accept these terms and conditions in full. Do not continue to use Nearzon if you do not agree to take all of the terms and conditions stated on this page. Our services are available only to individuals who can form legally binding contracts under applicable law.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>2. Cookies</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        We employ the use of cookies. By accessing Nearzon, you agreed to use cookies in agreement with the Nearzon's Privacy Policy. Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>3. License & Intellectual Property</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        Unless otherwise stated, Nearzon and/or its licensors own the intellectual property rights for all material on Nearzon. All intellectual property rights are reserved. You may access this from Nearzon for your own personal use subjected to restrictions set in these terms and conditions. You must not republish, sell, rent, or sub-license material from Nearzon.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>4. User Accounts and Comments</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        Certain parts of this website offer the opportunity for users to post and exchange opinions and information in certain areas of the website. Nearzon does not filter, edit, publish or review Comments prior to their presence on the website. You are entirely responsible for maintaining the confidentiality of your account information, including your password.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>5. Limitation of Liability and Disclaimer</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. We will not be liable for any indirect, special, or consequential loss or damage arising under this disclaimer or in connection with our website.
                    </Paragraph>

                    <Title level={3} style={{ color: '#FF8110', marginTop: 30 }}>Contact Us</Title>
                    <Paragraph style={{ fontSize: 16, lineHeight: '1.8', color: '#4a4a4a' }}>
                        If you have any queries regarding any of our terms, please contact us at <a href="mailto:support@nearzon.com" style={{ color: '#0B1F4D', fontWeight: 600 }}>support@nearzon.com</a>.
                    </Paragraph>
                </Card>
            </div>
            <Footer />
        </div>
    );
};

export default TermsAndConditions;
